import numeral from 'numeral';

import currencyList from '@/components/helpers/currency-list';
import { FormattersTypes } from '@/services/types/formatter';
import { FORMATS } from '@/services/constants/format';
import compare_reports from '@/views/formatters/compare_reports';

export default ({ vtag, component, ctx, data, key, decimal = 2 }: FormattersTypes) => {
  component.tag = 'span';

  let val = data[key] || 0;
  const { currency } = ctx.$store.getters.reportParams;

  const value = numeral(val).format(FORMATS[decimal]);


  if(Array.isArray(data[key])){
    return compare_reports({
      vtag,
      beforeValue:currencyList[currency] || '$ ',
      data:[
        numeral(data[key][0] || 0).format(FORMATS[decimal]),
        numeral(data[key][1] || 0).format(FORMATS[decimal]),
        numeral(data[key][2] || 0).format(FORMATS[decimal]),
        numeral(data[key][3] || 0).format(FORMATS[decimal])
      ],
    });
  }
  
  return vtag('div', {
    class: {
      'class-name': true,
      ...(key == 'reports-profit' && val < 0 ? {'class-name-red': true}: { }),
      ...(key == 'reports-profit' && val > 0 ? {'class-name-green': true}: { })
    }
  },
  [vtag('span', { class: { 'currency': true } }), [currencyList[currency] || '$ ', value]]);
}
